module.exports = __webpack_public_path__ + "static/media/boatImage.636f40bb.jpg";